export default class StaffEvaluationConfig {
    constructor(thresholdDeviation, thresholdSevereDeviation, thresholdNegativeDeviation, thresholdUnit) {
        this.thresholdDeviation = thresholdDeviation;
        this.thresholdSevereDeviation = thresholdSevereDeviation;
        this.thresholdNegativeDeviation = thresholdNegativeDeviation;
        this.thresholdUnit = thresholdUnit;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        return new StaffEvaluationConfig(
            data.thresholdDeviation,
            data.thresholdSevereDeviation,
            data.thresholdNegativeDeviation,
            data.thresholdUnit,
        );
    }

    serialize() {
        return {
            thresholdDeviation: this.thresholdDeviation,
            thresholdSevereDeviation: this.thresholdSevereDeviation,
            thresholdNegativeDeviation: this.thresholdNegativeDeviation,
            thresholdUnit: this.thresholdUnit,
        };
    }
}
